
export default {
  name: 'SlideComponent',
  props: {
    list: Array,
    title: {
      type: String, 
      default:''
    },
    src: {
        type: String,
        default: ''
    },
      action :{
      type: String,
      default:''
    },
    type: {
      type: String,
      default: 'actions'
    }
  },
  data: () => ({

  }),
  methods: {
        getPictureUrl (url) {
        return require(`@/assets/Images/${url}`)
    },
}
}
